import { usePublicFlowImageUrl } from "@/lib/hooks/use-public-flow/use-image";
import type { FlowPageComponent } from "@/lib/types/flow";
import { ImageRenderer } from "@/pages/clients/detail/flows/instance/component-renderers/image-renderer";

/**
 * The `image` component on the public flow (QL-429). The stored URL needs an
 * advisor session, so the image is loaded from the URL the server hands out
 * for this component instead. Nothing renders until it is known.
 */
export function PublicImageRenderer({ component }: { component: FlowPageComponent }) {
  const { url, alt } = usePublicFlowImageUrl(component.id);
  if (!url) return null;
  return <ImageRenderer config={{ url, alt }} />;
}
